<template>
  <section class="main-service">
    <div class="main-title">
      <html-view :value="$t('main.service.title1')" tag="h3" />
      <html-view :value="$t('main.service.subtitle1')" tag="small" />
    </div>
    <div class="main-content">
      <div class="service-desc">
        <!--          <img src="@/static/image/main/pc/season_1_bg.jpg" alt="">-->
        <div class="player-wrap">
          <video
            ref="video"
            :muted="isMute"
            loop
            playsinline
            poster="~@/static/image/main/main_baemin_reset.jpg"
          >
            <source src="~@/static/video/main_baemin_reset.mp4" type="video/mp4">
            Sorry, your browser doesn't support embedded videos.
          </video>
          <div class="player-control">
            <button
              type="button"
              class="btn-stop"
              @click="isPlay = !isPlay"
            >
              <icon-stop v-if="!isPlay" />
              <icon-play v-else />
            </button>

            <button type="button" class="btn-mute" @click="isMute = !isMute">
              <icon-sound-off v-if="isMute" />
              <icon-sound-on v-else />
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import iconPlay from '@/static/svg/play.svg'
import iconStop from '@/static/svg/stop.svg'
import iconSoundOff from '@/static/svg/sound-off.svg'
import iconSoundOn from '@/static/svg/sound-on.svg'

export default {
  components: {
    iconPlay,
    iconStop,
    iconSoundOff,
    iconSoundOn
  },
  data () {
    return {
      io: null,
      isPlay: false,
      isMute: true,
    }
  },
  watch: {
    isPlay (play) {
      if (play) {
        this.$refs.video.currentTime = 0
        const playPromise = this.$refs.video.play()

        if (playPromise !== undefined) {
          playPromise.then(video => {
            video.play()
          }).catch(e => {})
        }
      } else {
        this.$refs.video.pause()
      }
    }
  },
  mounted () {
    this.onObserver()
  },
  beforeDestroy () {
    this.io.disconnect()
  },
  methods: {
    onObserver () {
      if (!('IntersectionObserver' in window) ||
          !('IntersectionObserverEntry' in window) ||
          !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
        return false
      }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach(({ isIntersecting }) => {
          this.isPlay = !!isIntersecting
        })
      }, {
        threshold: [0],
        rootMargin: '0px 0px 0px 0px'
      })

      this.io.observe(this.$el)
    }
  }
}
</script>
